import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import  dayjs, { Dayjs } from "dayjs";

export interface ServiceReducerState {
  userLoginDetails: any[];
  offlineCar: any[];
  onlineCar: any[]
  isMuted: boolean;
  userMobileNumber: string
  searchShow: boolean;
  isSidebar: boolean;
  remainingWatchTime: any;
  totalWatchTime: any,
  remainingLiveWatchTime:any,
  totalLiveWatchTime: any,
  loadFlag:boolean
  activeCarDetails:any;
  selectedDate:Dayjs | null
  // Multi-day range (YYYY-MM-DD, max 20 days). Set = range mode: graph and
  // snapshots cover the range, no video. Picking a single day clears it.
  dateRange: { start: string; end: string } | null
  activeIndex:number
  globalZoom: number,
}

const initialState: ServiceReducerState = {
  userLoginDetails: [],
  offlineCar: [],
  onlineCar: [],
  isMuted: false,
  userMobileNumber: "",
  searchShow: false,
  isSidebar: false,
  remainingWatchTime: "",
  totalWatchTime: 0,
  remainingLiveWatchTime: "",
  totalLiveWatchTime: 0,
  loadFlag:true,
  activeCarDetails:{},
  selectedDate:dayjs(new Date()),
  dateRange: null,
  activeIndex:0,
  globalZoom: 1,
};

const serviceSlice = createSlice({
  name: 'service',
  initialState,
  reducers: {
    setUserLoginDetails(state, action: PayloadAction<any[]>) {
      state.userLoginDetails = action.payload;
    },
    setOfflineCar(state, action: PayloadAction<any[]>) {
      state.offlineCar = action.payload;
    },
    setOnlineCar(state, action: PayloadAction<any[]>) {
      state.onlineCar = action.payload;
    },
    setIsMuted(state, action: PayloadAction<boolean>) {
      state.isMuted = action.payload;
    },
    setMobileNumber(state, action: PayloadAction<string>) {
      state.userMobileNumber = action.payload;
    },
    setSearchShow(state, action: PayloadAction<boolean>) {
      state.searchShow = action.payload;
    },
    setSideBarAction(state, action: PayloadAction<boolean>) {
      state.isSidebar = action.payload;
    },
    setWatchTime(state, action: PayloadAction<any>) {
      state.remainingWatchTime = action.payload;
    },
    addWatchTime: (state, action) => {
      state.totalWatchTime += action.payload;
    },
    resetWatchTime: (state) => {
      state.totalWatchTime = 0;
    },
    setLiveWatchTime(state, action: PayloadAction<any>) {
      state.remainingLiveWatchTime = action.payload;
    },
    addLiveWatchTime: (state, action) => {
      state.totalLiveWatchTime += action.payload;
    },
    resetLiveWatchTime: (state) => {
      state.totalLiveWatchTime = 0;
    },
    setLoadFlag: (state, action) => {
      state.loadFlag =action.payload;
    },
    setActiveCarDetails: (state, action) => {
      state.activeCarDetails =action.payload;
    },
    setSelectedDate: (state, action) => {
      state.selectedDate =action.payload;
      state.dateRange = null;
    },
    setDateRange: (state, action) => {
      state.dateRange = action.payload;
    },
    setActiveIndex: (state, action) => {
      state.activeIndex =action.payload;
    },
    setGlobalZoom: (state, action) => {
      state.globalZoom = action.payload;
    }
  },

});

export const { setUserLoginDetails,
  setOfflineCar,
  setOnlineCar,
  setIsMuted,
  setMobileNumber,
  setSearchShow,
  setSideBarAction,
  setWatchTime,
  addWatchTime,
  resetWatchTime,
  setLiveWatchTime,
  addLiveWatchTime,
  resetLiveWatchTime,
  setLoadFlag,
  setActiveCarDetails,
  setSelectedDate,
  setDateRange,
  setActiveIndex,
  setGlobalZoom
} = serviceSlice.actions;

export default serviceSlice.reducer;
